import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { LocalStorageService } from '@services/local-storage.service';

@Injectable()
export class JwtTokenInterceptor implements HttpInterceptor {
  private localStorageService = inject(LocalStorageService);

  intercept(request: HttpRequest<string | object>, next: HttpHandler): Observable<HttpEvent<string | object>> {
    if (!request.url.endsWith('refresh')) {
      if (request.headers.get('Authorization') !== null) {
        return next.handle(request);
      } else {
        const token = this.getCurrentUser();
        const refreshToken = this.localStorageService.getRefreshToken();
        let authReq = token
          ? request.clone({
              setHeaders: {
                Authorization: 'Bearer ' + token
              }
            })
          : request;
        if (request.url.endsWith('logout') && refreshToken) {
          authReq = authReq.clone({
            setHeaders: {
              'refresh-token': refreshToken
            }
          });
        }

        return next.handle(authReq);
      }
    } else {
      return next.handle(request);
    }
  }

  private getCurrentUser() {
    return this.localStorageService.getToken();
  }
}
